import { Fragment } from 'react';
import PhotoComponentCustom from '../../../../commons/components/Album';
import Loading from '../../../../commons/components/Loading';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import Slider from '../../../../commons/components/Slider';
import { formatDateKorea } from '../../../../utils/helpers';
import InfiniteScroll from 'react-infinite-scroll-component';

type props = {
  dataAlbum: any,
  isProcessing: Boolean,
};

const SelfieTab = ({
  dataAlbum,
  onPhotoClick,
  photoSelected,
  isProcessing,
  params,
  fetchMoreDataPaginate,
  lastPage,
  currentPage,
}: props) => {

  const fetchMoreData = () => {
    let paramPage = {
      ...params,
      page: params.page + 1,
    };
    console.log(params, lastPage, currentPage, 'fetchMoreData AllTab');
    if (params.page < lastPage) {
      fetchMoreDataPaginate(paramPage);
    }
  };
  const loadingDiv = (
    <div className="pt-3 pl-3 pr-3">
      <SkeletonLoadingComponent width={100} />
      <SkeletonLoadingComponent
        cssClass={'photo-selector-slide'}
        type={'album'}
      />
    </div>
  );

  return (
    <>
      {isProcessing && lastPage <= 1 ? (
        loadingDiv
      ) : !dataAlbum || Object.keys(dataAlbum).length <= 0 ? (
        <div className="container mt-5 pt-5">
          <div className="row pt-5">
            <div className="col-12">
              <p className="text-center p-0 m-0">해당하는 데이터가 없습니다</p>
            </div>
          </div>
        </div>
      ) : (
        <InfiniteScroll
          dataLength={Object.keys(dataAlbum).length}
          next={fetchMoreData}
          hasMore={currentPage < lastPage ? true : false}
          loader={loadingDiv}
        >
          {Object.keys(dataAlbum).map((day) => (
            <Fragment key={day}>
              <p className="tabs__content__section__time ml-2 mb-2">
                {formatDateKorea(day)} {/*2021년 12월 12일*/}
              </p>
              {/* <Slider
                    pagination={false}
                    autoplay={false}
                    classSlider="swiper-pagination__custom"
                    classSwiper="swiper-custom"
                    slidesPerView={3}
                  > */}
              <div className="img-list">
                {(dataAlbum[day] ?? []).map((item, key) => (
                  <PhotoComponentCustom
                    key={key}
                    photoClass={`photo-selector-slide`}
                    src={item.path}
                    id={item.id}
                    item={item}
                    onClick={onPhotoClick}
                    photoSelected={photoSelected}
                  />
                ))}
              </div>
            </Fragment>
          ))}
        </InfiniteScroll>
      )}
    </>
  );
};

export default SelfieTab;
